import { useTranslation } from 'react-i18next';
import React, {  useEffect, useState } from "react";
import { Table,Drawer} from "antd";
import {useContractModel} from '../contractParticularsModel'
import {usecontractDetailsModel} from './detailsModel'


export  const LogDrawer=({mode,rowCode})=> {
    const {t} = useTranslation()
const  {logdatasource} =usecontractDetailsModel()
const {logVisable,setLogVisable}=useContractModel()



const columns=[
    {
        title:  t(`contractManagement.view.logDrawer.车辆牌照`),
        width: 80,
        dataIndex: 'vehicleCode',
    },
    {
        title:  t(`contractManagement.view.logDrawer.操作对象`),
        width: 80,
        dataIndex: 'operateName',
    },
     {
        title:  t(`contractManagement.view.logDrawer.操作类型`),
        width: 80,
        dataIndex: 'type',
    },
    {
        title:  t(`contractManagement.view.logDrawer.操作结果`),
        width: 100,
        dataIndex: 'result',
        
    },
    {
        title:  t(`contractManagement.view.logDrawer.操作内容`),
        width: 160,
        dataIndex: 'operateContent',
        
    },
    {
        title:  t(`contractManagement.view.logDrawer.操作人`),
        width: 140,
        dataIndex: 'createUser',
        
    },
    {
        title:  t(`contractManagement.view.logDrawer.操作时间`),
        width: 140,
        dataIndex: 'createTime',
        
    },
]

const onCancel =()=>{
    setLogVisable(false)
}



return (
    <Drawer 
    title= { t(`contractManagement.view.logDrawer.操作日志`)}
    open={logVisable}
    onClose={onCancel}
    width={800}
> 
 
    <div style={{ marginTop: "10px"}}>
    <Table
    rowKey={record => record.vehicleId}
    columns={columns}  
    dataSource={logdatasource}
    scroll={{ y: 600 }} 
    />
    </div>

</Drawer >
    
)
}